import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CaseStatus, ClosedReason } from '@taksikortti/shared';
import { api } from './client';

export interface PlannedCase {
  korttinumero: string;
  caseId: string;
  status: CaseStatus;
  closedReason: ClosedReason | null;
  flagged: boolean;
  notes: string;
  yritys: string | null;
  yTunnus: string | null;
  palvelutunnus: string | null;
  kuljettaja: string | null;
  firstContactAt: string | null;
  lastContactAt: string | null;
  closedAt: string | null;
  sourceRow: number;
  fillColour: string | null;
}

export interface MigrationPlan {
  trips: { imported: number; skipped: number; failures: { row: number; reason: string }[] };
  cases: PlannedCase[];
  demoted: { korttinumero: string; demotedCaseIds: string[] }[];
  warnings: string[];
}

export interface MigrationResponse {
  dryRun: boolean;
  plan: MigrationPlan;
}

export function useMigrateExcel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ file, commit }: { file: File; commit: boolean }) => {
      const buf = await file.arrayBuffer();
      return api<MigrationResponse>(
        `/migrate-excel?commit=${commit ? 'true' : 'false'}`,
        {
          method: 'POST',
          rawBody: true,
          headers: {
            'content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          },
          body: buf,
        },
      );
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cases'] });
    },
  });
}
